import React from 'react';
import _ from 'underscore';

import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { SpaceHeaderWithTotalItemsCount } from '~src/spacesPlatform/components/header/SpaceHeaderWithTotalItemsCount';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { Messages } from '../../../../codegen/Localize';
import { AddGroupsButton } from '../../../components/AddGroupsButton';

export interface AllGroupsSpaceOwnProps {
  readonly siteName: string;
}

export interface AllGroupsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedGroups: number;
  readonly canSessionUserManageUsers: boolean;
  readonly canSessionUserCreateGroup: boolean;
}

export interface AllGroupsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly fetchResourceActions: () => void;
}

export type AllGroupsSpaceProps = AllGroupsSpaceOwnProps & AllGroupsSpaceStateProps & AllGroupsSpaceDispatchProps;

export class AllGroupsSpace extends React.PureComponent<AllGroupsSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.groups() });
    this.props.requestSpaceContents();
    if (getSessionManagementServiceInstance().isAdminProfilesEnabled()) {
      this.props.fetchResourceActions();
    }
  }

  public componentDidUpdate(prevProps: AllGroupsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.groups()}
          testId={'groups'}
          count={this.props.numberOfFetchedGroups}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addGroupButton() },
            }}
            emptyStateProps={{
              primaryMessage: Messages.groupsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  };

  private addGroupButton = () => {
    if (!this.props.canSessionUserCreateGroup) {
      return null;
    }
    return (
      <>
        <AddGroupsButton
        buttonText={Messages.addGroup()}
        canSessionUserManageUsers={this.props.canSessionUserCreateGroup}
        />
      </>
    );
  };
}
